import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./quick_add_eligibility.js";
//#region src/quick_add_eligibility_helper.ts
var quick_add_eligibility_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(eligibility) {
	switch (eligibility) {
		case "has-no-mod-groups": return "Has no mod groups";
		case "has-mod-groups-no-required-choices": return "Has mod groups, no required choices";
		case "has-required-mod-groups-are-preselected": return "All required mod groups are preselected";
	}
}
//#endregion
export { name, quick_add_eligibility_helper_exports };

//# sourceMappingURL=quick_add_eligibility_helper.js.map